import { useState, useEffect } from 'react';
import { DashboardLayout } from '../components/Dashboard';
import checkCircleIcon from '../static/images/check-circle.svg';
import { ModalImage } from '../components/ModalImage';
import SectionTap from '../components/SectionTap';
import ButtonDownloadPDF from '../components/ButtonDownloadPDF';
import { useNavigate, useParams } from 'react-router-dom';
import { ComplianceController } from '../core/controller/ComplianceCtrl';
import { toast } from 'react-toastify';
import { toastError } from '../core/toast/toastAlert';
import { formatDateStr, validKycStatus } from '../core/function/function-generic';
import { complianceDetailsDTO } from '../interfaces/complianceDetails';
import LoadingComponent from '../components/loading/loading';
import { ResponseDTO } from '../interfaces/response';
import { kycStatus } from '../core/enum';

type ComplianceProps = {
    onSearchGen: string;
};

export const ComplianceDetails = ({ onSearchGen }: ComplianceProps) => {
    const complianceController = new ComplianceController()
    const navigate = useNavigate()
    const { id } = useParams()
    const [datatap, setdatatap] = useState<any[]>([])
    const [optionActive, setOptionActive] = useState<string>('');
    const [dataCompliance, setdataCompliance] = useState<complianceDetailsDTO>();
    const [isLoading, setisLoading] = useState<boolean>(false)

    useEffect(() => {
        setdatatap([{
            name: 'Personal information',
            class: 'w-full p-4' +
                'text-[#0000] font-[Montserrat] leading-[27px]' +
                ' not-italic font-bold text-[17px] text-center pb-2.5'
        }])
        setOptionActive('Personal information')
        getComplianceDetailsByid(Number(id))
    }, [])

    const [open, setOpen] = useState<boolean>(false)

    const handleOpen = () => setOpen(!open)

    const onsearchFilter = (nameTap: string) => {
        setOptionActive(nameTap)
    };

    const getComplianceDetailsByid = async (id: number) => {
        setisLoading(true)
        const response: ResponseDTO = await complianceController.getComplianceDetailsByid(id)
        if (response.data.statusCode >= 400) {
            setisLoading(false)
            toast.error(response.data.message, toastError)
            return
        }
        setisLoading(false)
        setdataCompliance(response.data.data)
    };

    return (
        <>
            <LoadingComponent isOpen={isLoading} />
            <DashboardLayout pageTitle='Compliance' onSearchGen={onSearchGen}>
                <main className='mx-8 mt-6' id='content-print'>
                    <div className='text-[14px] font-bold flex flex-wrap flex-auto justify-between items-baseline w-full h-full'>
                        <div className='flex justify-center cursor-pointer' onClick={() => navigate('/compliance')}>
                            <button>
                                <svg className='w-[17px] h-[17px]' viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M15.9014 8.4707H1.90137M1.90137 8.4707L8.90137 15.4707M1.90137 8.4707L8.90137 1.4707"
                                        stroke="black"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round" />
                                </svg>
                            </button>
                            <h1 className='text-[24px] font-bold m-2'>{dataCompliance?.fullname}</h1>
                        </div>
                        <div className='flex mb-10'>
                            <div className='flex items-center mr-2'>
                                <span className='mr-2'>Status:</span>
                                <div className={`w-[7.5rem] cursor-default rounded-md p-2 text-center ${kycStatus[validKycStatus(dataCompliance?.statuskyc)][3]} border-2`}>
                                    <span className={`w-full fontPageTitle600 ${kycStatus[validKycStatus(dataCompliance?.statuskyc)][2]}`}>{kycStatus[validKycStatus(dataCompliance?.statuskyc)][0]}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='w-full flex justify-between mb-10'>
                        <div>
                            <SectionTap onsearchFilter={onsearchFilter} datatap={datatap} optionActive={optionActive} />
                        </div>
                        <div>
                            <ButtonDownloadPDF />
                        </div>
                    </div>
                    <section className='grid sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-1 xl:grid-cols-3 mb-10 gap-6'>
                        <div className='border-2 border-solid border-[#DADADA] py-2.5 px-6 rounded-[6px]'>
                            <p className="text-[#000] font-[Montserrat] leading-normal not-italic font-semibold text-[15px]">Process</p>
                            <div className='w-full py-2.5'>
                                <ul className="max-w-md space-y-1 text-gray-500 list-inside flex flex-col">
                                    {
                                        dataCompliance?.aiprise?.aml_info?.status === 'COMPLETED' ? (
                                            <li className="flex items-center">
                                                <img src={checkCircleIcon} alt="checkImg" className='w-6 h-6 me-2 flex-shrink-0' />
                                                Anti-money Laundering (AML)
                                            </li>
                                        ) : (<><p>{'N/A'}</p></>)
                                    }
                                    {
                                        dataCompliance?.aiprise?.id_info?.status ? (
                                            <li className="flex items-center">
                                                <img src={checkCircleIcon} alt="checkImg" className='w-6 h-6 me-2 flex-shrink-0' />
                                                ID Info
                                            </li>
                                        ) : (<><p>{'N/A'}</p></>)
                                    }
                                    {
                                        dataCompliance?.aiprise?.face_match_info?.status === 'COMPLETED' ? (
                                            <li className="flex items-center">
                                                <img src={checkCircleIcon} alt="checkImg" className='w-6 h-6 me-2 flex-shrink-0' />
                                                Face Match
                                            </li>
                                        ) : (<><p>{'N/A'}</p></>)
                                    }
                                    {
                                        dataCompliance?.aiprise?.face_liveness_info.status === 'COMPLETED' ? (
                                            <li className="flex items-center">
                                                <img src={checkCircleIcon} alt="checkImg" className='w-6 h-6 me-2 flex-shrink-0' />
                                                Face Liveness
                                            </li>
                                        ) : (<><p>{'N/A'}</p></>)
                                    }
                                </ul>
                            </div>
                        </div>

                        <div className='border-2 border-solid border-[#DADADA] py-2.5 px-6 rounded-[6px] col-span-2'>
                            <p className="text-[#000] font-[Montserrat] leading-normal not-italic font-semibold text-[15px]">User Provided Imaged</p>
                            <div className='w-full flex flex-wrap gap-4 py-2.5'>

                                <img
                                    src={dataCompliance?.docuri}
                                    alt="checkImg"
                                    className={`
                                        ${['Passport'].includes(dataCompliance?.docuri as string)
                                            ? 'w-[50%] h-[250px]'
                                            : 'w-[250px] h-[250px] aspect-[3/2] grow'} 
                                        `}
                                />

                                <img
                                    src={dataCompliance?.docbackuri as string}
                                    alt="checkImg"
                                    className='w-[250px] h-[250px] aspect-[3/2] grow'
                                />


                                <img
                                    src={dataCompliance?.selfieuri as string}
                                    alt="checkImg"
                                    className='w-[250px] h-[250px] aspect-[3/2] grow'
                                />

                            </div>
                        </div>
                        {/*
                        <div className='border-2 border-solid border-[#DADADA] py-2.5 px-6 rounded-[6px]'>
                            <p className="text-[#000] font-[Montserrat] leading-normal not-italic font-semibold text-[15px]">Case Activity</p>
                            <ol className="relative text-gray-500 border-s border-gray-200 dark:border-[#005ff9]">
                                <li className="my-6 ms-6 border-gray-200 dark:border-[#005ff9]">
                                    <span className="absolute flex items-center justify-center w-2 h-2 rounded-full -start-4 ring-4 ring-white"></span>
                                    <h3 className="font-medium font-[Montserrat] leading-normal not-italic text-[12px] text-[#000]">KYC Completed</h3>
                                    <p className="font-normal font-[Montserrat] leading-normal not-italic text-[10px] text-[#00000099]">{formatDate(dataCompliance?.updatedAt as string)}</p>
                                </li>
                                <li className="mb-6 ms-8">
                                    <span className="absolute flex items-center justify-center w-8 h-8 rounded-full -start-4 ring-4 ring-white dark:bg-[#005ff9]">
                                        <svg className="w-3.5 h-3.5 text-white dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 12">
                                            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1 5.917 5.724 10.5 15 1.5" />
                                        </svg>
                                    </span>
                                    <p className="pt-2 font-medium font-[Montserrat] leading-normal not-italic text-[12px] text-[#000]">{dataCompliance?.firstname + ' ' + dataCompliance?.lastname}</p>
                                </li>
                            </ol>
                            <div className='ms-8 mt-[-22px]'>
                                <div className="font-normal font-[Montserrat] leading-normal not-italic text-[10px] text-[#00000099]">Compliance Officer</div>
                                <div className="font-medium font-[Montserrat] leading-normal not-italic text-[12px] text-[#000]">The user profile looks good.</div>
                                <div className="font-normal font-[Montserrat] leading-normal not-italic text-[10px] text-[#00000099]">Sep 09, 2023 03:30PM.</div>
                            </div>
                        </div>
                        */}

                        <div className='border-2 border-solid border-[#DADADA] py-2.5 px-6 rounded-[6px]'>
                            <p className="text-[#000] font-[Montserrat] leading-normal not-italic font-semibold text-[15px]">User Info</p>
                            <div className='flex flex-wrap flex-auto gap-6 my-8 justify-center'>
                                <div className='w-12 flex-grow'>
                                    <p className="text-[#00000099] font-[Montserrat] not-italic font-medium text-[16px]">Country</p>
                                    <span className="text-[#000] font-[Montserrat] not-italic font-medium text-[16px] leading-normal">{dataCompliance?.aiprise?.id_info?.issue_country || 'N/A'}</span>
                                </div>
                                <div className='w-12 flex-grow'>
                                    <p className="text-[#00000099] font-[Montserrat] not-italic font-medium text-[16px]">Nationality</p>
                                    <span className="text-[#000] font-[Montserrat] not-italic font-medium text-[16px] leading-normal">{/* dataCompliance?.aiprise?.id_info?.nationality ||  */'N/A'}</span>
                                </div>
                                <div className='w-12 flex-grow'>
                                    <p className="text-[#00000099] font-[Montserrat] not-italic font-medium text-[16px]">Address</p>
                                    <span className="text-[#000] font-[Montserrat] not-italic font-medium text-[16px] leading-normal">{dataCompliance?.aiprise?.id_info?.address?.full_address || 'N/A'}</span>
                                </div>
                            </div>
                            <div className='flex flex-wrap flex-auto gap-6 my-8'>
                                <div className='w-12 flex-grow'>
                                    <p className="text-[#00000099] font-[Montserrat] not-italic font-medium text-[16px]">City</p>
                                    <span className="text-[#000] font-[Montserrat] not-italic font-medium text-[16px] leading-normal">{dataCompliance?.city || 'N/A'}</span>
                                </div>
                                <div className='w-12 flex-grow'>
                                    <p className="text-[#00000099] font-[Montserrat] not-italic font-medium text-[16px]">Occupation</p>
                                    <span className="text-[#000] font-[Montserrat] not-italic font-medium text-[16px] leading-normal">N/A</span>
                                </div>
                                <div className='w-12 flex-grow'>
                                    <p className="text-[#00000099] font-[Montserrat] not-italic font-medium text-[16px]">Day of Birth</p>
                                    <span className="text-[#000] font-[Montserrat] not-italic font-medium text-[16px] leading-normal">{formatDateStr(dataCompliance?.aiprise?.id_info?.birth_date as string) || 'N/A'}</span>
                                </div>
                            </div>
                        </div>

                        <div className='border-2 border-solid border-[#DADADA] py-2.5 px-6 rounded-[6px] col-span-2'>
                            <p className="text-[#000] font-[Montserrat] leading-normal not-italic font-semibold text-[15px]">ID Info</p>
                            <div className='flex flex-wrap flex-auto gap-6 mt-8'>
                                <div className='flex-grow'>
                                    <p className="text-[#00000099] font-[Montserrat] not-italic font-medium text-[16px]">Document Type</p>
                                    <span className="text-[#000] font-[Montserrat] not-italic font-medium text-[16px] leading-normal">{dataCompliance?.aiprise?.id_info?.id_type || 'N/A'}</span>
                                </div>
                                <div className='flex-grow'>
                                    <p className="text-[#00000099] font-[Montserrat] not-italic font-medium text-[16px]">Identity Number</p>
                                    <span className="text-[#000] font-[Montserrat] not-italic font-medium text-[16px] leading-normal">{dataCompliance?.aiprise?.id_info?.id_number || 'N/A'}</span>
                                </div>
                                <div className='flex-grow'>
                                    <p className="text-[#00000099] font-[Montserrat] not-italic font-medium text-[16px]">Expiry Date</p>
                                    <span className="text-[#000] font-[Montserrat] not-italic font-medium text-[16px] leading-normal">{dataCompliance?.aiprise?.id_info?.id_expiry_date || 'N/A'}</span>
                                </div>
                                <div className='flex-grow'>
                                    <p className="text-[#00000099] font-[Montserrat] not-italic font-medium text-[16px]">ID Issue Date</p>
                                    <span className="text-[#000] font-[Montserrat] not-italic font-medium text-[16px] leading-normal">{dataCompliance?.aiprise?.id_info?.id_issue_date || 'N/A'}</span>
                                </div>
                            </div>
                            <div className='flex flex-wrap flex-auto gap-6 my-8'>
                                <div className='flex-grow'>
                                    <p className="text-[#00000099] font-[Montserrat] not-italic font-medium text-[16px]">First Name</p>
                                    <span className="text-[#000] font-[Montserrat] not-italic font-medium text-[16px] leading-normal">{dataCompliance?.aiprise?.id_info?.first_name || 'N/A'}</span>
                                </div>
                                <div className='flex-grow'>
                                    <p className="text-[#00000099] font-[Montserrat] not-italic font-medium text-[16px]">Last Name</p>
                                    <span className="text-[#000] font-[Montserrat] not-italic font-medium text-[16px] leading-normal">{dataCompliance?.aiprise?.id_info?.last_name || 'N/A'}</span>
                                </div>
                                <div className='flex-grow'>
                                    <p className="text-[#00000099] font-[Montserrat] not-italic font-medium text-[16px]">Gender</p>
                                    <span className="text-[#000] font-[Montserrat] not-italic font-medium text-[16px] leading-normal">{dataCompliance?.aiprise?.id_info?.gender || 'N/A'}</span>
                                </div>
                                <div className='flex-grow'>
                                    <p className="text-[#00000099] font-[Montserrat] not-italic font-medium text-[16px]">Birth Date</p>
                                    <span className="text-[#000] font-[Montserrat] not-italic font-medium text-[16px] leading-normal">
                                        {formatDateStr(dataCompliance?.aiprise?.id_info?.birth_date as string) || 'N/A'}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </section>
                </main>
                <ModalImage open={open} onClick={handleOpen} />
            </DashboardLayout>
        </>
    )
}